module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point04_04_activity-277e308a68f42655ecdcf4ddfd607d28.jpg";